import { useCallback, useEffect, useRef } from 'react';

/** Fires onIdle after N minutes without user activity (security auto-logout). */
export default function useIdleTimeout(onIdle, timeoutMinutes = 30, enabled = true) {
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (!enabled) return;
    timerRef.current = setTimeout(() => onIdle(), timeoutMinutes * 60 * 1000);
  }, [onIdle, timeoutMinutes, enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
    const handleActivity = () => resetTimer();
    events.forEach((e) => window.addEventListener(e, handleActivity, { passive: true }));
    resetTimer();
    return () => {
      events.forEach((e) => window.removeEventListener(e, handleActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer, enabled]);
}
